import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-professional-summary',
  templateUrl: './professional-summary.component.html',
  styleUrls: ['./professional-summary.component.scss']
})
export class ProfessionalSummaryComponent implements OnInit {
  @Input() user: User;
  secondaryIndustries: any[];

  constructor(private sharedService: SharedService) { }

  ngOnInit() {
    this.sharedService.getSecondaryIndustries().subscribe((response) => {
      this.secondaryIndustries = response;
    })
  }

  getIndustryName(value: number) {
    if (!this.secondaryIndustries) {
      return;
    }
    let item =  this.secondaryIndustries.find((item) => item.id === value);
    if (!item) {
      return 'Information not available';
    }
    return item.name;
  }

}
